// extracted by mini-css-extract-plugin
module.exports = {"Modal":"sellerDashboard_Modal__18OPY","Root":"sellerDashboard_Root__RxKFi","buyerFormReadonly":"sellerDashboard_buyerFormReadonly__1l4ge"};